import React, { Suspense, useEffect, useRef } from 'react';
import MainLayout from '../layoutfolder/MainLayout';
import PublicLayout from '../layoutfolder/PublicLayout';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from '../pages/Login';
import Signup from '../pages/Signup';
import Pagenotfound from '../pages/Pagenotfound';
import ConfirmSignUp from '../pages/ConfirmSignUp';
import { Amplify, Hub, Auth } from 'aws-amplify';
import ForgotPassword from '../pages/ForgotPassword';
import NewPassword from '../pages/NewPassword';
import { useSelector, useDispatch } from 'react-redux';
import { logIn, logOut, setGoogleUserLoginCompleted } from '../redux/reducers/login';
import { updateUserDetailsOnIn, updateUserDetailsOnOut, updateUserDetailsOnSignIn } from '../redux/reducers/userDetails';
import PaymentEntries from '../pages/NewFigma/PaymentEntries.jsx';
import Receipt from '../pages/NewFigma/Receipt.jsx';
import AllPurchaseandExpense from '../pages/NewFigma/AllPurchaseandExpense.jsx';
import AllJournalEntries from '../pages/NewFigma/AllJournalEntries.jsx';
import AllCustomers from '../pages/NewFigma/AllCustomers.jsx';
import AllSuppliers from '../pages/NewFigma/AllSuppliers.jsx';
import AllSalesInvoices from '../pages/NewFigma/AllSalesInvoice.jsx';
import CreateLedgerAccount from '../pages/NewFigma/CreateLedgerAccount.jsx';
import { skipOpen } from '../redux/reducers/companySkip.js';
import AllDebitNote from '../pages/NewFigma/AllDebitNote.jsx';
import AllCreditNote from '../pages/NewFigma/AllCreditNote.jsx';
import CloseBooksOfAccounts from '../pages/NewFigma/CloseBooksOfAccounts.jsx';
import CloseFinancialYear from '../pages/NewFigma/CloseFinancialYear.jsx';
import AddUserManagement from '../pages/NewFigma/AddUserManagement.jsx';
import AddRecurringInvoice from '../pages/NewFigma/AddRecurringInvoice.jsx';
import TermsAndServices from '../pages/NewFigma/TermsAndServices.jsx';
import PrivacyPolicy from '../pages/NewFigma/PrivacyPolicy.jsx';
import AllAccounts from '../pages/NewFigma/AllAccounts.jsx';
import AllGroups from '../pages/NewFigma/AllGroups.jsx';
import CreateNewFinancialYear from '../pages/NewFigma/CreateNewFinancialYear.jsx';
import PaymentSettings from '../pages/NewFigma/PaymentSetting.jsx';
import ItemSettings from '../pages/NewFigma/ItemSettings.jsx';
import SupportPage from '../pages/NewFigma/SupportPage.jsx';
import UpiTextField from '../components/formElements/UpiTextField.jsx';
import PartySettings from '../pages/NewFigma/PartySettings.jsx';
import AddNewReceipts from '../pages/PrimeFigma/NewReceiptVoucherv2.jsx';
import AddPaymentVoucher from '../pages/PrimeFigma/NewPaymentVoucherv2.jsx';
import { fetchPaymentSettings } from '../redux/reducers/PaymentSettingsSlice.js';
import { fetchInvoiceSettings } from '../redux/reducers/InvoiceSettings.js';
import ImportNew from '../pages/NewFigma/ImportNew.jsx';
import FinancialYearClosing from '../pages/PrimeFigma/CompanySetup/Components/FinancialYearSettings.jsx';
// import NewReports from "../pages/PrimeFigma/Reports/Reports";
import { fetchCompany } from '../redux/reducers/CompanySlice.js';

import { injectTokensIntoAmplify } from '../auth.tsx';

import { API, graphqlOperation } from 'aws-amplify';
import { logOutStop, logoutStart } from '../redux/reducers/logout.js';
import { loginCognitoUser, logoutCognitoUser } from '../graphql/';
import { persistor } from '../redux/store';
import axios from 'axios';
import { fetchUserPreference } from '../redux/reducers/UserPreference';

import NewPos from '../pages/PrimeFigma/NewPOS.jsx';
import AddNewItem from '../pages/PrimeFigma/ItemPage/AddNewItem.jsx';
import LinkToInvoices from '../pages/PrimeFigma/LinkToInvoices/LinkToInvoices.jsx';
import { getUserAttributes } from '../library/shared.js';

import LoginSignUp from '../pages/Login/LoginSignUp.jsx';
import LogoutPage from '../pages/Logout.jsx';
import SignoutPage from '../pages/auth/SignoutPage.jsx';

// import theme, { Themefn } from "../styles/Themecolors.jsx";
import NewItemListPage from '../pages/PrimeFigma/ItemPage/NewItemListPage.jsx';
import AllPos from '../pages/NewFigma/AllPos.jsx';

import PrimeAddNewItem from '../pages/PrimeFigma/ItemPage/PrimeAddNewItem.jsx';
import NewDynamicEntryTable from '../pages/PrimeFigma/ItemPage/NewDynamicEntryTable.jsx';
import EWayBill from '../pages/NewFigma/eWayBill/eWayBill.jsx';
import CreateManualJournal from '../pages/NewFigma/CreateManualJournal.jsx';
import FinancialYearSettings from '../pages/PrimeFigma/CompanySetup/Components/FinancialYearSettings';
import { useFetchCompanylistQuery } from '../redux/apis/companyList.api.js';
import NewCompanySetup from '../pages/PrimeFigma/CompanySetup/newCompanySetup.jsx';
import CreateSales from '../pages/PrimeFigma/CreateSales.jsx';
import CreatePurchase from '../pages/PrimeFigma/CreatePurchase.jsx';
import CreateCreditNote from '../pages/PrimeFigma/CreateCreditNote.jsx';
import CreateDebitNote from '../pages/PrimeFigma/CreateDebitNote.jsx';
import CreatePos from '../pages/PrimeFigma/CreatePos.jsx';
import { getCognitoUserSessions } from '../graphql/';
import config from '../aws-exports.js';
import NewReports from '../pages/NewFigma/newReports/index.jsx';
import { LedgerTransactionPage } from '../pages/LedgerTransaction/TransactionsPage.jsx';
import InvoiceSettings from '../pages/InvoiceSettings/page.jsx';
import OpeningBalancev2 from '../pages/NewFigma/OpeningBalancev2.jsx';
import AddNewCustomer from '../pages/NewFigma/AddCustomer/AddNewCustomer.jsx';
import NewGeneralSetting from '../pages/NewFigma/GeneralSettings/newGeneralSetting.jsx';
import { skipReset } from '../redux/reducers/companySkipSave.js';
import DashboardHome from '../pages/Dashboard/DashboardHome.jsx';
import ListEwayBill from '../pages/NewFigma/eWayBill/listEwayBill.jsx';
import API_ENDPOINTS from '../apiEndpoints.js';
import { resetNavigationState, setNavigationBlocked } from '../redux/reducers/controllNavigation.js';
import Summary from '../pages/NewFigma/eWayBill/summary.jsx';
import { IS_LOCAL } from '../config.js';
import { EmailSettings } from '../features/Email';
import ClosingStockSummary from '../features/StockManagement/pages/ClosingStockSummary';
import StockItemWiseSummary from '../features/StockManagement/pages/StockItemWiseSummary';
import { onlogoutCognitoUser } from '../graphql/postgress_graphql';
import { ManagePayments } from '../features/Payment/index';
import { VersionUpdateNotification } from '../features';
import { CreateFinancialYear } from '../features/createFinancialYear';
import { exportRoutes } from '../features/Exports';
import { useFeatureFlag } from '../features/FeatureFlag';
import { SkeletonLoader } from '../components';
import { ChatBotPage } from '../features/ChatBot';
import { SimplePeriodDropdownTest } from '../pages/testPages/SimplePeriodDropdownTest';
import { postLogToLambda } from '../utils/logging';
import NewLoginDetected from '../pages/NewLoginDetected/NewLoginDetected';
import SessionExpired from '../pages/auth/SessionExpired/SessionExpired';
import WindowClosedSessionExpiredPage from '../pages/auth/WindowClosedSessionExpiredPage';
import { tokenRefreshInDb } from '../pages/auth/tokenRefreshInDb';
import { validateUserSession } from '../pages/auth/validateUserSession';
import CompanySetup from '../features/CompanySetup/Page';
import Reports from '../pages/NewFigma/Reports';
import ReportsPage from '../pages/NewFigma/ReportsPage';
import ReportBody from '../pages/NewFigma/ReportsPage/ReportBody';
import EmptyState from '../pages/NewFigma/ReportsPage/ReportBody/EmptyState';

const TestPreview = React.lazy(() => import('../_tests/InvoicepreviewTest/index.js'));
console.log(config);
const origin = window.location.origin;
const InDomain = 'https://in.ledgerx.biz/';
console.log({ origin });
if (origin === 'https://in.ledgerx.biz') {
  config.oauth.redirectSignIn = InDomain;
  config.oauth.redirectSignOut = 'https://in.ledgerx.biz/logout';
}
console.log({ config });
Amplify.configure(config);

const Routesmap = ({ nav }) => {
  const { loginStatus } = useSelector((state) => state.loginActions);

  const companyReducer = useSelector((state) => state.companyReducer);
  console.log(companyReducer, 'companyReducer');
  // const { data: companyList, isLoading, isError, error } = useFetchCompanylistQuery();

  const userPreferenceAndFY = useSelector((state) => state.userPrefrenceandReducer);

  const { isBlocked } = useSelector((state) => state.controllNavigationSlice);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  let callback = () => dispatch(logIn());
  const constructLogoutUrl = (config) => {
    const cognitoDomain = config.oauth.domain;
    const clientId = config.aws_user_pools_web_client_id;
    const signoutUrl = config.oauth.redirectSignOut;
    return `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${signoutUrl}`;
  };
  const handleSignout = async (data) => {
    console.log('logg', JSON.stringify(data.value));
    let incomingsession = data.value.data.onlogoutCognitoUser.linkedsessionid;
    console.log('incomingsession', incomingsession);
    const currentsession = localStorage.getItem('deviceKey');
    console.log('currentsession', currentsession);

    if (incomingsession == currentsession) {
      return;
    } else {
      postLogToLambda('another session found' + JSON.stringify({ data, currentsession }), 'routes map');
      return navigate('/new-login-detected');
    }
    let sessions = await API.graphql(graphqlOperation(getCognitoUserSessions));

    if (sessions?.data?.getCognitoUserSessions?.length) {
      const currentSessionId = localStorage.getItem('deviceKey');
      const currentSession = sessions.data.getCognitoUserSessions.find((session) => session?.linkedsessionid == currentSessionId);
      if (currentSession) {
        return;
      } else {
        postLogToLambda(JSON.stringify({ data, currentSessionId, currentSession, sessions }), 'routesmap 2');
      }
    }
    postLogToLambda(JSON.stringify({ data, sessions }), 'routesmap 1');
    const devicekey = localStorage.getItem('deviceKey');

    console.log({ sessions, key: devicekey });
    let accessToken = null;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (key.startsWith('CognitoIdentityServiceProvider') && key.endsWith('.accessToken')) {
        accessToken = localStorage.getItem(key);
        break;
      }
    }
    if (accessToken) {
      // const option = {
      //   method: "POST",
      //   url: API_ENDPOINTS.REACT_APP_GLOBAL_SIGNOUT_URL,
      //   headers: { Authorization: accessToken },
      // };
      // axios(option).catch((err) => {
      //   console.log(err);
      // });
    }
    const logouturl = constructLogoutUrl(config);
    axios.get(logouturl);
    persistor.purge(); // purge redux
    dispatch(skipReset());
    dispatch(logoutStart());
    try {
      localStorage.clear();
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      }
      dispatch(logOut());

      dispatch(logOutStop());
      localStorage.removeItem('emailID');
      localStorage.removeItem('mobileNo');
    } catch (error) {
      dispatch(logOutStop());
    }
  };

  useEffect(() => {
    let subscription;

    const setupSubscription = async () => {
      if (loginStatus) {
        try {
          const user = await getUserAttributes();
          console.log({ user });
          subscription = API.graphql(
            graphqlOperation(onlogoutCognitoUser, {
              cognitousername: user?.sub,
            })
          ).subscribe({
            next: (data) => {
              handleSignout(data);
            },
            error: (error) => console.log(error),
          });
          console.log({ subscription });
        } catch (error) {
          console.error('Error setting up subscription:', error);
        }
      }
    };

    setupSubscription();

    return () => subscription?.unsubscribe();
  }, [loginStatus]);
  useEffect(() => {
    if (companyReducer?.Loaded && companyReducer?.companyDetails && userPreferenceAndFY?.render && !userPreferenceAndFY?.loading) {
      dispatch(fetchUserPreference());
    }
  }, [companyReducer, userPreferenceAndFY?.render]);

  const subscriptionsRef = useRef([]);

  // useEffect(() => {
  //   if (
  //     !loginStatus ||
  //     !userPreferenceAndFY?.userPreference ||
  //     !companyReducer?.companyDetails
  //   )
  //     return;

  //   const userID = userPreferenceAndFY.userPreference[0]?.UserID;
  //   const companyID = companyReducer?.companyDetails?.CompanyID;

  //   if (!userID || !companyID) return;

  //   const subscriptions = [];

  //   const addSubscription = (config, variables, callback) => {
  //     subscriptions.push(
  //       API.graphql(graphqlOperation(config, variables)).subscribe({
  //         next: callback,
  //         error: (error) =>
  //           console.error(`Error in subscription: ${config.name}`, error),
  //       })
  //     );
  //   };

  //   ["SelectedFinYear"].forEach((attribute) =>
  //     addSubscription(
  //       oncreateUserPreference,
  //       { UserID: userID, AttributeTypeCD: attribute },
  //       () => {
  //         dispatch(balanceSheetApi.util.invalidateTags(["BalanceSheetData"]));
  //         dispatch(trialBalanceApi.util.invalidateTags(["TrialBalanceData"]));
  //         dispatch(profitNLossApi.util.invalidateTags(["ProfitNLossData"]));
  //         dispatch(fetchUserPreference());
  //         dispatch(resetBusinessOverViewState());
  //         dispatch(setResetOpeningBalance());
  //       }
  //     )
  //   );

  //   // List of subscription configurations with shared dispatch actions
  //   const commonSubscriptions = [
  //     oncreateSalesInvoice,
  //     oncreatePurchaseInvoice,
  //     onCreateAccountMaster,
  //     oncreateTransactionDetailsArray,
  //     oncreateAccountOpeningBalancesTransaction,
  //     onCreateTransactionMaster,
  //     ondeleteTransactionMaster,
  //     onupdateAccountMaster,
  //     ondeleteAccountMaster,
  //     onCreateAccountGroupMaster,
  //     onupdateAccountGroupMaster,
  //     ondeleteAccountGroupMaster,
  //     oncreateItemTransaction,
  //     oncreateItemCategorymaster,
  //     oncreateBankDetails,
  //     oncreatePartyTransaction,
  //     oncreateCrDrNoteTransactionsArray,
  //     oncreateTransactionWithSpecificTime,
  //     onupdateItemmaster,
  //     ondeleteItemmaster,
  //     onCreateItemmaster,
  //   ];

  //   // Subscribe to each config and dispatch shared actions on data change
  //   commonSubscriptions.forEach((config) =>
  //     addSubscription(config, { CompanyID: companyID }, () => {
  //       dispatch(balanceSheetApi.util.invalidateTags(["BalanceSheetData"]));
  //       dispatch(trialBalanceApi.util.invalidateTags(["TrialBalanceData"]));
  //       dispatch(profitNLossApi.util.invalidateTags(["ProfitNLossData"]));
  //       dispatch(resetBusinessOverViewState());
  //       dispatch(setResetOpeningBalance());
  //       dispatch(setItemStockSummaryReRender());
  //       if (config === onCreateAccountGroupMaster)
  //         dispatch(listGroupMasterApi.util.invalidateTags(["listGroupMaster"]));
  //     })
  //   );

  //   subscriptionsRef.current = subscriptions;
  //   return () => subscriptionsRef.current.forEach((sub) => sub?.unsubscribe());
  // }, [loginStatus, userPreferenceAndFY, companyReducer, dispatch]);

  const sos = () => {
    const accessToken = new URLSearchParams(window.location.search).get('token');
    const idToken = new URLSearchParams(window.location.search).get('idToken');
    const refreshToken = new URLSearchParams(window.location.search).get('refreshToken');
    if (accessToken) {
      injectTokensIntoAmplify(accessToken, idToken, refreshToken, callback);
    }
  };

  let themeFetch = () => {
    // if (loginStatus) {
    //   const fetchUserThemePreference = async () => {
    //     try {
    //       const response = await API.graphql(
    //         graphqlOperation(listUserPreference)
    //       );
    //       let attributeValue = response.data.listUserPreference.find((e) => e.attributetypecd === "SideBarPin").attributevalue
    //       // const attributeValue =
    //       //   response?.data?.getUserThemePreference?.attributevalue;
    //       if (attributeValue !== theme?.palette?.TmId.id) {
    //         // setTimeout(() => {
    //         Themefn(attributeValue);
    //         // }, 1500);
    //       }
    //     } catch (error) {
    //       console.log("error", error);
    //     } finally {
    //       // Any final actions if needed
    //     }
    //   };
    //   // Call the async function
    //   fetchUserThemePreference();
    // }
  };
  const FetchData = async () => {
    try {
      dispatch(fetchPaymentSettings());
      dispatch(fetchCompany());
      dispatch(resetNavigationState());
      let userData = await getUserAttributes();
      console.log({ userData });
      dispatch(updateUserDetailsOnSignIn(userData));
    } catch (e) {
      console.log(e, 'error');
    } finally {
      themeFetch();
    }
  };

  useEffect(() => {
    if (loginStatus) {
      FetchData();
    }

    return () => {};
  }, [loginStatus]);

  // Session refresh logic - call tokenRefreshInDb when user is inactive for more than 5 minutes 10 seconds
  useEffect(() => {
    if (!loginStatus) {
      // Clear timer and global function when user logs out
      if (window.sessionRefreshTimer) {
        clearTimeout(window.sessionRefreshTimer);
        window.sessionRefreshTimer = null;
      }
      if (window.resetSessionRefreshTimer) {
        delete window.resetSessionRefreshTimer;
      }
      return;
    }

    const REFRESH_INTERVAL = 5 * 60 * 1000 + 10 * 1000; // 5 minutes 10 seconds

    const resetSessionRefreshTimer = () => {
      if (window.sessionRefreshTimer) {
        clearTimeout(window.sessionRefreshTimer);
      }

      window.sessionRefreshTimer = setTimeout(async () => {
        console.log('User has been inactive for 5 minutes 10 seconds, refreshing session in DB...');
        let sp = await validateUserSession();
        if (!sp.isValid) {
          postLogToLambda('invalid session in db when refreshing token on random check', 'routesmap 2');
          navigate('/session-expired?3');
        }
        // Reset timer for next cycle
        resetSessionRefreshTimer();
      }, REFRESH_INTERVAL);
    };

    // Make function globally accessible for tokenRefresh event
    window.resetSessionRefreshTimer = resetSessionRefreshTimer;

    // Start the initial timer
    resetSessionRefreshTimer();

    // Cleanup when loginStatus changes
    return () => {
      if (window.sessionRefreshTimer) {
        clearTimeout(window.sessionRefreshTimer);
        window.sessionRefreshTimer = null;
      }
      if (window.resetSessionRefreshTimer) {
        delete window.resetSessionRefreshTimer;
      }
    };
  }, [loginStatus]);

  useEffect(() => {
    sos();
    checkIfAuthenticated();

    // Set up localStorage change listener for cross-tab logout
    const handleStorageChange = (event) => {
      if (event.key === 'logoutTrigger' && event.newValue) {
        console.log('Logout trigger detected in localStorage:', event.newValue);

        // Check if we're not already on logout page
        const currentPath = window.location.pathname;
        if (currentPath !== '/logout') {
          console.log('Performing cross-tab logout cleanup...');

          // Purge redux store - this handles all state cleanup and navigation
          persistor.purge();
        } else {
          console.log('Ignoring logout trigger - already on logout page');
        }
      }
    };

    // Listen for localStorage changes
    window.addEventListener('storage', handleStorageChange);
    console.log('Cross-tab logout listener set up (localStorage)');

    Hub.listen('auth', async (data) => {
      console.log({ data });
      switch (data.payload.event) {
        case 'signIn':
          // dispatch(updateUserDetailsOnIn(data?.payload?.data?.storage?.email));
          let datas = {
            userName: data?.payload?.data?.attributes?.name || data.payload.data.signInUserSession.idToken.given_name,
            email: data?.payload?.data?.attributes?.email,
            designation: data?.payload?.data?.attributes?.['custom:Designation'],
          };

          localStorage.setItem('UserName', data?.payload?.data?.attributes?.name || data.payload.data.signInUserSession.idToken.given_name);

          // Store the current login time
          localStorage.setItem('loginTime', new Date().toISOString());
          break;
        case 'cognitoHostedUI':
          dispatch(logIn());
          Auth.currentSession()
            .then((data) => {
              let idToken = data.getIdToken();
              let email = idToken.payload.email;
            })
            .catch((err) => console.log(err));
          const devicekey = Date.now()?.toString();
          localStorage.setItem('deviceKey', devicekey);
          let createSession = await API.graphql(
            graphqlOperation(loginCognitoUser, {
              LinkedSessionID: devicekey,
            })
          );
          dispatch(setGoogleUserLoginCompleted());
          console.log({ createSession });
          localStorage.setItem('sessionID', createSession.data?.loginCognitoUser?.[0]?.sessionid);
          localStorage.setItem('emailID', data?.payload?.data?.storage?.email);

          // Store the current login time
          localStorage.setItem('loginTime', new Date().toISOString());

          // dispatch(updateUserDetailsOnIn(data?.storage?.email));

          break;
        case 'signUp':
          break;
        case 'confirmSignUp':
          dispatch(skipOpen());
          localStorage.setItem('sidebarNavbar', 'yes');

          break;
        case 'signOut':
          break;
        case 'oAuthSignOut':
          break;
        case 'resendSignUp':
          break;
        case 'tokenRefresh': {
          console.log('Token refresh event detected, attempting to refresh session in DB...');
          // Call tokenRefreshInDb and only reset timer if successful
          try {
            const success = await tokenRefreshInDb();
            if (success) {
              console.log('Session refresh successful, resetting timer...');
              // Reset the session refresh timer since user is active and session refreshed
              if (window.resetSessionRefreshTimer) {
                window.resetSessionRefreshTimer();
              }
            } else {
              postLogToLambda('invalid session in db when refreshing token', 'routesmap 1');
              navigate('/session-expired?4');
            }
          } catch (error) {
            console.log('Session refresh error:', error);
          }
          break;
        }
        default:
          break;
      }
    });

    // Cleanup function
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const checkIfAuthenticated = async () => {
    let currentSession = null;
    try {
      currentSession = await Auth.currentSession();

      localStorage.setItem('email', currentSession.idToken.payload.email);
    } catch (err) {}
  };
  const FreezeStatus = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  return loginStatus === true ? (
    <MainLayout nav={nav}>
      <Suspense fallback={<SkeletonLoader />}>
        <Routes>
          <Route path="/signout" element={<SignoutPage />}></Route>
          <Route path="/logout" element={<LogoutPage />}></Route>
          <Route path="/create-new-financial-year" element={<CreateFinancialYear />}></Route>
          <Route path="/new-login-detected" element={<NewLoginDetected />}></Route>
          <Route path="session-expired" element={<SessionExpired />}></Route>
          <Route path="window-closed-session-expired" element={<WindowClosedSessionExpiredPage />}></Route>

          {/* <Route path="/addsupplier" element={<AddSupplier />}></Route> */}
          {/* <Route path="/salesInvoiceReport" element={<SalesInvoiceReport />}></Route> */}
          {/* <Route path="/invoiceTaxableold" element={<InvoiceTaxableOld />}></Route>
    <Route path="/invoiceNonTaxableold" element={<InvoiceNonTaxableOld />}></Route> */}
          {/* <Route path="/goodslist" element={<GoodsList />}></Route> */}
          {/* <Route path="/serviceslist" element={<ServicesList />}></Route> */}
          {/* <Route path="/customerList" element={<CustomerList />}></Route> */}
          {/* <Route path="/supplierList" element={<SupplierList />}></Route> */}
          {/* <Route path="/posold" element={<POSOld />}></Route> */}
          {/* <Route path="/allpurchaseandexpense" element={<PurchaseandExpenseList />}></Route> */}
          {/* <Route path="/journalentries" element={<JournalEntries />}></Route> */}

          {/* new figma */}

          <>
            {FreezeStatus !== 1 && (
              <>
                <Route path="/newemail" element={<EmailSettings />}></Route>
                <Route path="/addsupplier" element={<AddNewCustomer key={'add'} />}></Route>
                <Route path="/editcustomer" element={<AddNewCustomer key={'edit'} />}></Route>
                <Route path="/editsupplier" element={<AddNewCustomer key={'edit'} />}></Route>
                <Route path="/addcustomer" element={<AddNewCustomer key={'add'} />}></Route>
                <Route path="/addewaybill" element={<EWayBill key={'add'} />}></Route>
                <Route path="/editewaybill" element={<EWayBill key={'edit'} />}></Route>
                <Route path="/ewaybilllist" element={<ListEwayBill key={'add'} />}></Route>
                <Route path="/addjournalentry" element={<CreateManualJournal key={'add'} />}></Route>
                <Route path="/editjournalentry" element={<CreateManualJournal key={'edit'} />}></Route>
                <Route path="/addcreditnote" element={<CreateCreditNote key={'add'} />}></Route>
                <Route path="/editcreditnote" element={<CreateCreditNote key={'edit'} />}></Route>
                <Route path="/edititem" element={<AddNewItem key={'edit'} />}></Route>
                <Route path="/additem" element={<AddNewItem key={'add'} />}></Route>
                <Route path="/entryTable" element={<NewDynamicEntryTable key={'add'} />}></Route>
                <Route path="/primeadditem" element={<PrimeAddNewItem key={'add'} />}></Route>
                <Route path="/newpos" element={<CreatePos key={'add'} />}></Route>
                <Route path="/editpos" element={<CreatePos key={'edit'} />}></Route>
                <Route path="/editnewinvoicetax" element={<CreateSales key={'edit'} />}></Route>
                <Route path="/addnewinvoicetax" element={<CreateSales key={'add'} />}></Route>
                <Route path="/addnewpurchasetax" element={<CreatePurchase key={'add'} />}></Route>
                <Route path="/editnewpurchasetax" element={<CreatePurchase key={'edit'} />}></Route>
                <Route path="/adddebitnote" element={<CreateDebitNote key={'add'} />}></Route>
                <Route path="/editdebitnote" element={<CreateDebitNote key={'edit'} />}></Route>
                <Route path="/editpaymententries" element={<AddPaymentVoucher key={'edit'} />}></Route>
                <Route path="/editreceipts" element={<AddNewReceipts key={'edit'} />}></Route>
                <Route path="/addpaymententries" element={<AddPaymentVoucher />}></Route>
                <Route path="/addreceipts" element={<AddNewReceipts />}></Route>
                {/* <Route
                    path="/openingbalancev2"
                    element={<OpeningBalancev3 />}
                  ></Route> */}
              </>
            )}

            <Route path="/" element={<DashboardHome />}></Route>

            <Route path="/allPos" element={<AllPos key={'view'} />}></Route>
            <Route path="/openingbalance" element={<OpeningBalancev2 />}></Route>

            <Route path="/import-data" element={<ImportNew />}></Route>
            <>
              {exportRoutes.map((route) => (
                <Route key={route.path} path={route.path} element={route.element}>
                  {route.children?.map((child) => (
                    <Route key={child.path || 'index'} index={child.index} path={child.path} element={child.element} />
                  ))}
                </Route>
              ))}
            </>

            {/* <Route path="/testPage" element={<MyComponent />}></Route> */}
            {/* <Route path="/import-dataNew" element={<ImportNew />}></Route> */}
            <Route path="/emailsettings" element={<EmailSettings title={'Email Settings'} top={90} left={80} />}></Route>

            <Route path="/viewjournalentry/*" element={<CreateManualJournal key={'view'} />}></Route>
            <Route path="/paymententries" element={<PaymentEntries />}></Route>
            <Route path="/receipts" element={<Receipt />}></Route>
            <Route path="/allpurchaseandexpense" element={<AllPurchaseandExpense />}></Route>
            {/* <Route path="/testcompanysetup" element={<TestCompanySetup />}></Route> */}
            <Route path="/config" element={<CompanySetup />} />
            <Route path="/companysetup" element={<NewCompanySetup />}>
              {/* <Route path="emailsettings" element={<EmailSettings />} /> */}
              <Route path="InvoiceSettings" element={<InvoiceSettings title={'Regular Invoice Print Template Settings'} top={90} />} />
              <Route path="PaymentSettings" element={<PaymentSettings />} />

              <Route path="financialYearClosing" element={<FinancialYearClosing />}></Route>
              <Route path="closebooksofaccounts" element={<CloseBooksOfAccounts />}></Route>
            </Route>
            <Route path="/journalentries" element={<AllJournalEntries />}></Route>

            <Route path="/customerList" element={<AllCustomers />}></Route>
            <Route path="/supplierList" element={<AllSuppliers />}></Route>
            <Route path="/salesInvoiceReport" element={<AllSalesInvoices />}></Route>
            {/* <Route path="/reportsNew" element={<NewReports />}></Route> */}

            <Route path="/viewnewinvoicetax/*" element={<CreateSales key={'view'} />}></Route>

            <Route path="/viewnewpurchasetax/*" element={<CreatePurchase key={'view'} />}></Route>

            <Route path="/viewdebitnote/*" element={<CreateDebitNote key={'view'} />}></Route>

            <Route path="/viewcreditnote/*" element={<CreateCreditNote key={'view'} />}></Route>

            <Route path="/viewcustomer/*" element={<AddNewCustomer key={'view'} />}></Route>
            {/* <Route
          path="/addsupplier"
          element={<AddSupplier key={"add"} />}
        ></Route> */}
            <Route path="/viewsupplier/*" element={<AddNewCustomer key={'view'} />}></Route>
            {/* <Route
          path="/addpaymententries"
          element={<AddPaymentEntry key={"add"} />}
        ></Route> */}
            <Route path="/viewpaymententries/*" element={<AddPaymentVoucher key={'view'} />}></Route>
            {/* <Route
          path="/addreceipts"
          element={<AddReceipts key={"add"} />}
          ></Route> */}

            <Route path="/viewreceipts/*" element={<AddNewReceipts key={'view'} />}></Route>

            <Route path="/viewpos/*" element={<CreatePos key={'view'} />}></Route>
            <Route path="/linktoinvoices" element={<LinkToInvoices key={''} />}></Route>

            <Route path="/createledgeraccount" element={<CreateLedgerAccount />}></Route>
            <Route path="/viewitem/*" element={<AddNewItem key={'view'} />}></Route>

            <Route path="/newItemList" element={<NewItemListPage key={'list'} />}></Route>
            <Route path="/alldebitnote" element={<AllDebitNote />}></Route>
            <Route path="/allcreditnote" element={<AllCreditNote />}></Route>

          <Route path="/reports" element={<ReportsPage />}>
        <Route index element={<EmptyState />} />
        <Route path=":id" element={<ReportBody />} />
      </Route>
           
            <Route path="/defaultformats" element={<NewGeneralSetting topm={true} />}></Route>
            <Route path="/ewaybill" element={<EWayBill key={'add'} />}></Route>
            <Route path="/ewaySummary" element={<Summary />}></Route>
            <Route path="/addrecurringinvoice" element={<AddRecurringInvoice />}></Route>

            <Route path="/financialyearsettings" element={<FinancialYearSettings top={90} />}></Route>

            <Route path="/closefinancialyear" element={<CloseFinancialYear />}></Route>
            <Route path="/closebooksofaccounts" element={<CloseBooksOfAccounts top={90} />}></Route>
            <Route path="/adduser" element={<AddUserManagement />}></Route>
            <Route path="/accounts" element={<AllAccounts />}></Route>
            <Route path="/groups" element={<AllGroups />}></Route>
            <Route path="/invoiceSettings" element={<InvoiceSettings margin={75} left={86} />}></Route>
            <Route path="/PaymentSettings" element={<PaymentSettings title="Payment Settings" top={90} />}></Route>
            <Route path="/ItemSettings" element={<ItemSettings />}></Route>
            <Route path="/supportpage" element={<SupportPage />}></Route>
            <Route path="/upi" element={<UpiTextField />}></Route>
            <Route path="/partySettings" element={<PartySettings />}></Route>
            <Route path="/general-settings" element={<NewGeneralSetting />}></Route>
            <Route path="/inventory-transaction-summary" element={<StockItemWiseSummary variant="page" />}></Route>
            <Route path="/stock-item-wise-pl" element={<ClosingStockSummary />}></Route>
            <Route path="/LedgerTransactions/:id" element={<LedgerTransactionPage />}></Route>
            {IS_LOCAL && <Route path="/tests/*" element={<TestPreview />}></Route>}
            <Route path="/test-simple-period-dropdown" element={<SimplePeriodDropdownTest />}></Route>
            <Route path="/chatbot" element={<ChatBotPage />}></Route>
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/paymentsv2/*" element={<ManagePayments />}></Route>
          </>
        </Routes>
      </Suspense>
      <VersionUpdateNotification />
    </MainLayout>
  ) : (
    <PublicLayout>
      {/* public routes and Route use here */}
      {/* new figma */}

      <Routes>
        <Route path="/" element={<Root />}></Route>

        <Route path="login" element={<Login />}></Route>
        <Route path="Create_Account" element={<Signup />}></Route>
        <Route path="SupNew" element={<LoginSignUp />}></Route>
        <Route path="confirmsignup" element={<ConfirmSignUp />}></Route>
        <Route path="forgotpassword" element={<ForgotPassword />}></Route>
        <Route path="newpassword" element={<NewPassword />}></Route>
        <Route path="pagenotfound" element={<Pagenotfound />}></Route>

        {/* <Route path="*" element={<Navigate to="pagenotfound" />} /> */}
        <Route path="/*" element={<Navigate to="login" />} />
        <Route path="termsofservices" element={<TermsAndServices />}></Route>
        <Route path="privacypolicy" element={<PrivacyPolicy />}></Route>
      </Routes>
    </PublicLayout>
  );
};
const Root = () => {
  let navigate = useNavigate();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const codeParam = urlParams.get('code');
    if (!codeParam) {
      navigate('/login');
    }
  }, []);
  return <></>;
};
export default Routesmap;
